<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select
          v-model="search.siteId"
          clearable
          style="width:100px; margin-right: 20px;text-align:center"
        >
          <Option v-for="item in siteList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="约束类型" prop="constraintType">
          <Select clearable v-model="formValidate.constraintType" style="text-align:left">
            <Option
              v-for="item in constraintTypeList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="约束名称" prop="constraintName">
          <i-input v-model="formValidate.constraintName" placeholder="输入约束名称(警告邮件名称)"></i-input>
        </FormItem>

        <FormItem label="所属站点" prop="siteId">
          <Select
            clearable
            v-model="formValidate.siteId"
            style="text-align:left"
            @on-change="selectDevice"
          >
            <Option v-for="item in siteList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!-- deviceList -->
        <FormItem label="约束设备">
          <Row>
            <i-col span="11">
              <FormItem label="主设备">
                <Select
                  clearable
                  v-model="formValidate.constraintValueMap.primaryDeviceId"
                  style="text-align:left"
                >
                  <Option v-for="item in deviceList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="2">-</i-col>
            <i-col span="11">
              <FormItem label="备用设备">
                <Select
                  clearable
                  v-model="formValidate.constraintValueMap.standbyDeviceId"
                  style="text-align:left"
                >
                  <Option v-for="item in deviceList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </i-col>
          </Row>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "约束名称",
            align: "center",
            render(h, params) {
              return h("div", [h("span", {}, params.row.constraintName)]);
            }
          },
          {
            title: "约束类型",
            align: "center",
            render(h, params) {
              return h("div", [
                h(
                  "span",
                  {},
                  params.row.constraintType == 1 ? "主备约束" : "其他约束"
                )
              ]);
            }
          },
          {
            title: "约束值",
            align: "center",
            render(h, params) {
              return h("div", [h("span", {}, params.row.constraintValue)]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          constraintType: params.row.constraintType,
                          constraintName: params.row.constraintName,
                          constraintValueMap: params.row.constraintValueMap,
                          siteId: params.row.siteId,
                          flowConstraintId: params.row.flowConstraintId
                        };
                        this.selectDevice();
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.flowConstraintId;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true
      },
      // 查询
      search: {
        siteId: null //对应站点
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加",
        companyShow: false // 站点工艺图modal显示隐藏
      },
      // 表单数据
      formValidate: {
        constraintType: null,
        constraintName: null,
        constraintValueMap: {},
        siteId: null
      },
      // 验证
      ruleValidate: {
        constraintType: [{ required: true, message: "不能为空" }],
        constraintName: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
        siteId: [{ required: true, message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      // 枚举数据
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备列表
      constraintTypeList: [
        {
          id: 1,
          name: "主备约束"
        }
      ]
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        constraintType: null,
        constraintName: null,
        constraintValueMap: {},
        siteId: null
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getConstraintList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getConstraintDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postConstraintAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postConstraintEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        } else {
          this.$Message.warning("输入信息有误");
        }
      });
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 查询站点设备
    selectDevice() {
      this.$api.Deploy.getDeviceList_1(
        {paging:false,content: { siteId: this.formValidate.siteId } },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          this.deviceList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    }
  }
};
</script>